import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsJitsiComponent } from './simple-icons-jitsi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsJitsiComponent ],
    exports:      [ SimpleIconsJitsiComponent ],
    bootstrap:    []
})
export class SimpleIconsJitsiModule {}
